import { Add, Autorenew, CloudDownload, Delete, Done, ExpandMore, MoreHoriz, SettingsBackupRestore, SwapVert, Warning } from '@material-ui/icons';
import { ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Grid, IconButton, Typography, withStyles, withTheme, Menu, MenuItem, Modal, Button, TextField } from 'material-ui';
import { red } from 'material-ui/colors';
import React, { Component } from 'react';
import AppBarSpacing from './utils/AppBarSpacing';
import SubHeader from './components/SubHeader';
import EnhancedTooltip from './components/EnhancedTooltip'

const styles = {
  bundlesContainer: {
    padding: 32,
    '@media (max-width:599.95px)': {
      padding: '16px 8px'
    }
  },
  hideXXS: {
    '@media (max-width:399.95px)': {
      display: 'none'
    }
  }
};

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rearrangeMenuAnchor: null,
      rearrangeIndex: null,
      rearrangeIndexPosition: {
        first: false,
        second: false,
        secondToLast: false,
        last: false
      },

      requestConfirmation: false,
      confirmationDescription: '',
      confirmationText: '',
      confirmedCallback: (()=>{}),
      confirmationCanceledCallback: (()=>{}),

      addBundles: false,
      addText: ''
    };
  }

  render() {
    return (
      <React.Fragment>
        <SubHeader className={this.props.classes['top-app_bar_spacing-1']}>
          <Typography variant="title" color='inherit' style={{flexGrow: 1}}>
            Configure Bundles
          </Typography>

          {
            this.props.app.anyManifestLoadErrored()?
              <EnhancedTooltip title="Error Loading Bundles">
                <div>
                  <IconButton disabled style={{color: red[500]}}>
                    <Warning/>
                  </IconButton>
                </div>
              </EnhancedTooltip>
            :
              null
          }

          <EnhancedTooltip title="Restore Defaults">
            <IconButton color='inherit' onClick={()=>{
              this.requestConfirmation('This will delete all locally cached bundle information.', 'RESTORE DEFAULTS', ()=>{
                this.props.app.initializeDefaultAppManifestState(()=>{
                  this.props.app.saveAppManifestState();
                  this.props.app.loadMergeAndSaveCurrentManifests();
                });
              });
            }}>
              <SettingsBackupRestore/>
            </IconButton>
          </EnhancedTooltip>

          <EnhancedTooltip title="Update Bundles">
            <IconButton color='inherit' onClick={()=>this.props.app.loadMergeAndSaveCurrentManifests()}>
              <CloudDownload/>
            </IconButton>
          </EnhancedTooltip>

          <EnhancedTooltip title="Add Bundles">
            <IconButton color='inherit' onClick={()=>this.handleAddBundlesOpen()}>
              <Add/>
            </IconButton>
          </EnhancedTooltip>

        </SubHeader>
        <div className={`${this.props.classes["margin-app_bar_spacing-2"]} ${this.props.classes.bundlesContainer}`}>
          {
            this.props.manifestURLs.map((manifestURL, index) => {
              var manifestState = this.props.manifestStates[manifestURL];
              var manifest = this.props.manifests[manifestURL];
              
              var previouslyLoaded = Boolean(manifest);
              var indexPosition = {
                first: index === 0,
                second: index === 1,
                secondToLast: index === this.props.manifestURLs.length - 2,
                last: index === this.props.app.state.manifestURLs.length - 1
              };
              return (
                <ExpansionPanel key={manifestURL}>
                  <ExpansionPanelSummary expandIcon={<ExpandMore/>} style={{margin: 0, paddingLeft: 8}}>
                    
                    <Grid container direction='row' wrap='nowrap' justify='center' alignItems='center' style={{width: 'unset', paddingRight: 8}}>
                      <Grid item>

                        {
                          manifestState.load === 'unloaded'?
                            <IconButton disabled style={{color: this.props.theme.typography.display1.color ,marginTop: -17, marginBottom: -15}}>
                              <MoreHoriz/>
                            </IconButton>
                          :
                            null
                        }

                        {
                          manifestState.load === 'loading'?
                            <IconButton disabled style={{color: this.props.theme.typography.display1.color ,marginTop: -17, marginBottom: -15}}>
                              <Autorenew/>{/*TODO spin!*/}
                            </IconButton>
                          :
                            null
                        }

                        {
                          manifestState.load === 'loaded'?
                            <IconButton disabled style={{color: this.props.theme.typography.display1.color ,marginTop: -17, marginBottom: -15}}>
                              <Done/>
                            </IconButton>
                          :
                            null
                        }

                        {
                          manifestState.load === 'errored'?
                            <EnhancedTooltip title="Error Loading Bundle">
                              <div>
                                <IconButton disabled style={{color: red[500], marginTop: -17, marginBottom: -15}}>
                                  <Warning/>
                                </IconButton>
                              </div>
                            </EnhancedTooltip>
                          :
                            null
                        }

                      </Grid>
                    </Grid>

                    {
                      previouslyLoaded?
                        <Typography style={{marginRight: 16}}>{manifest.metadata.name}</Typography>
                      :
                        null
                    }

                    <Typography className={previouslyLoaded ? this.props.classes.hideXXS : ''} style={{flexGrow: 2, marginRight: 16, overflowWrap: 'break-word', color: this.props.theme.typography.display1.color, maxHeight: 200, overflowY: 'hidden'}}>{manifestURL}</Typography>
                    
                    <Grid container direction='row' wrap='nowrap' justify='center' alignItems='center' style={{width: 'unset'}}>
                      <Grid item>
                        {
                          this.props.manifestURLs.length > 1?
                            <IconButton style={{marginTop: -17, marginBottom: -15}} onClick={(e)=>{this.handleRearangeOpen(index, e.currentTarget, indexPosition);e.stopPropagation()}}>
                              <SwapVert/>
                            </IconButton>
                          :
                            null
                        }
                      </Grid>
                      <Grid item>
                        <IconButton style={{marginTop: -17, marginBottom: -15}} onClick={(e)=>{this.requestConfirmation('Removing a bundle will delete all locally cached information about it.', 'REMOVE', ()=>{this.handleDelete(index)});e.stopPropagation()}}>
                          <Delete/>
                        </IconButton>
                      </Grid>
                    </Grid>

                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    {
                      previouslyLoaded?
                        <Typography component='pre'>{JSON.stringify(manifest, null, 4)}</Typography>
                      :
                        <Typography>This manifest has never been successfully loaded...</Typography>
                    }
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              );
            })
          }
        </div>

        <Menu transitionDuration={150} anchorEl={this.state.rearrangeMenuAnchor} open={Boolean(this.state.rearrangeMenuAnchor)} onClose={this.handleRearangeClose.bind(this)}>
          {(this.state.rearrangeIndexPosition.first || this.state.rearrangeIndexPosition.second) ? null : <MenuItem onClick={()=>{this.handleRearrangeTop()}}>Top</MenuItem>}
          {this.state.rearrangeIndexPosition.first ? null : <MenuItem onClick={()=>{this.handleRearrangeRaise()}}>Raise</MenuItem>}
          {this.state.rearrangeIndexPosition.last ? null : <MenuItem onClick={()=>{this.handleRearrangeLower()}}>Lower</MenuItem>}
          {(this.state.rearrangeIndexPosition.last || this.state.rearrangeIndexPosition.secondToLast) ? null : <MenuItem onClick={()=>{this.handleRearrangeBottom()}}>Bottom</MenuItem>}
        </Menu>

        <Modal disableRestoreFocus={true} open={this.state.requestConfirmation} onClose={()=>{this.handleConfirmationClose(); this.state.confirmationCanceledCallback()}}>
          <div style={{position: 'absolute', width: this.props.theme.spacing.unit * 50, maxWidth: '100%', backgroundColor: this.props.theme.palette.background.paper, boxShadow: this.props.theme.shadows[5], padding: this.props.theme.spacing.unit * 4, top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
            <Typography variant="title">
              Are you sure?
            </Typography>
            <Typography variant="subheading">
              { this.state.confirmationDescription }
            </Typography>
            <br/>
            <Button onClick={()=>{this.handleConfirmationClose(); this.state.confirmationCanceledCallback()}}>
              CANCEL
            </Button>
            <Button onClick={()=>{this.handleConfirmationClose(); this.state.confirmedCallback()}} variant='raised' style={{color: 'white', backgroundColor: red[500], float: 'right'}}>
              {this.state.confirmationText}
            </Button>
          </div>
        </Modal>

        <Modal disableRestoreFocus={true} open={this.state.addBundles} onClose={()=>{this.handleAddBundlesClose()}}>
          <div style={{position: 'absolute', width: this.props.theme.spacing.unit * 50, maxWidth: '100%', backgroundColor: this.props.theme.palette.background.paper, boxShadow: this.props.theme.shadows[5], padding: this.props.theme.spacing.unit * 4, top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
            <Typography variant="title">
              Add Bundles
            </Typography>
            <Typography variant="subheading">
              Separate manifest URLs with commas. They must be properly escaped (e.g. no spaces).
            </Typography>
            <TextField
              id="multiline-static"
              label="Bundle manifest URLs"
              multiline
              margin="normal"
              style={{marginBottom: 40, width: '100%'}}
              error={this.state.addText !== '' && !this.validateAddText()}
              onChange={(e)=>{this.handleAddTextChange(e)}}
            />
            <br/>
            <Button onClick={()=>{this.handleAddBundlesClose();}}>
              CANCEL
            </Button>
            <Button disabled={this.state.addText === '' || !this.validateAddText()} onClick={()=>{this.props.app.setAndSaveManifestURLs(this.props.manifestURLs.concat(this.extractURLsFromAddText()));this.handleAddBundlesClose();}} variant='raised' color='primary' style={{float: 'right'}}>
              ADD
            </Button>
          </div>
        </Modal>
      </React.Fragment>
    );
  }

  handleRearangeOpen(index, target, indexPosition) {
    this.setState({
      rearrangeMenuAnchor: target,
      rearrangeIndex: index,
      rearrangeIndexPosition: indexPosition
    });
  }

  handleRearangeClose() {
    this.setState({
      rearrangeMenuAnchor: null,
      rearrangeIndex: null
    });
  }

  handleRearrangeTop() {
    var index = this.state.rearrangeIndex;
    var manifestURLs = this.props.manifestURLs;
    var url = manifestURLs.splice(index, 1)[0];
    manifestURLs.unshift(url);
    this.props.app.setManifestURLs(manifestURLs, ()=>{
      this.props.app.saveAppManifestState();
    });
    this.handleRearangeClose();
  }

  handleRearrangeRaise() {
    var index = this.state.rearrangeIndex;
    var manifestURLs = this.props.manifestURLs;
    manifestURLs.splice(index-1, 2, manifestURLs[index], manifestURLs[index-1]);
    this.props.app.setManifestURLs(manifestURLs, ()=>{
      this.props.app.saveAppManifestState();
    });
    this.handleRearangeClose();
  }

  handleRearrangeLower() {
    var index = this.state.rearrangeIndex;
    var manifestURLs = this.props.manifestURLs;
    manifestURLs.splice(index, 2, manifestURLs[index+1], manifestURLs[index]);
    this.props.app.setManifestURLs(manifestURLs, ()=>{
      this.props.app.saveAppManifestState();
    });
    this.handleRearangeClose();
  }

  handleRearrangeBottom() {
    var index = this.state.rearrangeIndex;
    var manifestURLs = this.props.manifestURLs;
    var url = manifestURLs.splice(index, 1)[0];
    manifestURLs.push(url);
    this.props.app.setManifestURLs(manifestURLs, ()=>{
      this.props.app.saveAppManifestState();
    });
    this.handleRearangeClose();
  }

  requestConfirmation(description, confirmationText, confirmedCallback, canceledCallback=()=>{}) {
    this.setState({
      requestConfirmation: true,
      confirmationDescription: description,
      confirmationText: confirmationText,
      confirmedCallback: confirmedCallback,
      confirmationCanceledCallback: canceledCallback
    });
  }

  handleConfirmationClose() {
    this.setState({
      requestConfirmation: false
    });
  }

  handleDelete(index) {
    var manifestURLs = this.props.manifestURLs;
    manifestURLs.splice(index, 1);
    this.props.app.setManifestURLs(manifestURLs, ()=>{
      this.props.app.saveAppManifestState();
    });
  }

  handleAddBundlesOpen() {
    this.setState({
      addBundles: true
    });
  }

  handleAddBundlesClose() {
    this.setState({
      addBundles: false,
      addText: ''
    });
  }

  handleAddTextChange(event) {
    this.setState({addText: event.target.value});
  }

  validateAddText() {
    var urls = this.extractURLsFromAddText();
    for(var i in urls) {
      if(urls[i] === '') {
        return false;
      }
      
      for(var j in this.props.manifestURLs) {
        if(urls[i] === this.props.manifestURLs[j]) {
          return false;
        }
      }
      
      if(i !== urls.length - 1) {
        for(var k = i + 1; k < urls.length; k++) {
          if(urls[i] === urls[k]) {
            return false;
          }
        }
      }
      
    }
    return true;
  }

  extractURLsFromAddText() {
    return this.state.addText.replace(' ', '').split(",");
  }
}

export default withTheme()(withStyles(Object.assign(styles, AppBarSpacing))(Settings));


// WEBPACK FOOTER //
// ./src/Settings.js